import { render, staticRenderFns } from "./ResetVerify.vue?vue&type=template&id=707ac36a&scoped=true&"
import script from "./ResetVerify.vue?vue&type=script&lang=js&"
export * from "./ResetVerify.vue?vue&type=script&lang=js&"
import style0 from "./ResetVerify.vue?vue&type=style&index=0&id=707ac36a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ac36a",
  null
  
)

export default component.exports